import React, { useState, useEffect } from "react";
import PageBanner from "../components/PageBanner";
import Layouts from "../layouts/Layouts";
import { Button } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import VideoPopup from "../components/VideoPopUp";
import AppointmentForm from "../components/Appointment";
import { FaCheckCircle, FaImage } from "react-icons/fa";
import { BsPlayCircle } from "react-icons/bs";
import { fetchServices, services } from "../locales/services";
import { useRefContext } from "../components/ScrollToAppointment";
import { useTranslation } from "react-i18next";
const Services = ({ formData, setFormData, handleSubmit }) => {
  const [video, setVideo] = useState(false);
  const [updatedServices, setUpdatedServices] = useState(services);
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();
  const { appointmentRef } = useRefContext();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [imageLoadingStates, setImageLoadingStates] = useState({});

  const handleImageLoad = (serviceId) => {
    setImageLoadingStates((prev) => ({
      ...prev,
      [serviceId]: true,
    }));
  };

  useEffect(() => {
    const initialLoadingStates = services.reduce((acc, service) => {
      acc[service.id] = true;
      return acc;
    }, {});
    setImageLoadingStates(initialLoadingStates);
  }, []);

  useEffect(() => {
    const loadServices = async () => {
      const data = await fetchServices();
      setUpdatedServices(data);
    };

    loadServices();
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (location.state?.scrollToAppointment && appointmentRef.current) {
      if (appointmentRef.current) {
        appointmentRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location, appointmentRef]);

  const handleGetAppointmentClick = (e) => {
    e.preventDefault();
    if (appointmentRef.current) {
      appointmentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    navigate({ state: { services } });
  }, []);
  const handleServiceClick = (service) => {
    console.log("service from the services page: " + service?.title);

    //navigate(`/service-details?serviceId=${service.sortOrder}`);
    navigate("/service-details", {
      state: { service, ...(service.image2 && { image2: service.image2 }) },
      serviceId: service.sortOrder,
    });
  };

  const truncateText = (text, length = 120) => {
    if (text.length > length) {
      return text.substring(0, length) + "...";
    }
    return text;
  };
  const sortedServices = updatedServices.sort(
    (a, b) => a.sortOrder - b.sortOrder
  );
  const getTranslatedValue = (field, lang) => {
    if (!field) return "";
    return field[lang] || field["en"] || "";
  };
  return (
    <Layouts footer={2} noNewsletters noheader>
      {video && <VideoPopup close={setVideo} />}
      {/**
      <PageBanner
        title={t("pageBanner.services")}
        pageName={t("pageBanner.services")}
        pageNumber="2"
      />
     */}{" "}
      <section className="services-area section-gap-top-less bg-color-grey">
        <div className="container">
          <div className="row justify-content-center service-loop">
            {sortedServices.map((service, index) => (
              <div key={index} className="col-lg-4 col-md-6 col-sm-8 mb-4">
                <div
                  style={{
                    maxHeight: windowWidth > 768 ? "470px" : "none",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    textAlign: "center",
                    flex: 1,
                    backgroundColor: "white",
                    position: "relative",
                    transition:
                      "background-color 0.3s ease, transform 0.3s ease",
                    cursor: "pointer",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                    padding: "30px",
                    marginBottom: "20px",
                    overflow: "hidden",
                    minWidth: "300px",
                    paddingBottom: "0",
                    paddingRight: "0",
                    paddingLeft: "0",
                    height: "100%",
                  }}
                  onClick={() => handleServiceClick(service)}
                  onMouseEnter={(e) => {
                    e.currentTarget.querySelector(".read-more").style.opacity =
                      "1";
                    e.currentTarget.querySelector(
                      ".read-more"
                    ).style.visibility = "visible";
                  }}
                  onMouseDown={(e) => {
                    e.currentTarget.style.transform = "scale(0.97)";
                  }}
                  onMouseUp={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      maxWidth: "200px",
                      height: "auto",
                      aspectRatio: "1 / 1",
                      borderRadius: "50%",
                      overflow: "hidden",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    {!imageLoadingStates[service.id] ? (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <FaImage
                          style={{
                            fontSize: "50%",
                            color: "#ddd",
                          }}
                        />
                      </div>
                    ) : (
                      <img
                        src={service.image}
                        alt={getTranslatedValue(service?.title, i18n)}
                        onLoad={() => handleImageLoad(service.id)}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingRight: "30px",
                      paddingLeft: "30px",
                      flexGrow: 1,
                      gap: "8px",
                    }}
                  >
                    <h4 className="title">
                      <Link>
                        {t(
                          `servicesPage.service${service.sortOrder}.${service?.title}`
                        )}
                      </Link>
                    </h4>
                    <p>
                      {truncateText(
                        t(
                          `servicesPage.service${service.sortOrder}.${service?.description}`
                        ),
                        150
                      )}
                    </p>
                  </div>

                  {/* Read More button */}
                  <div
                    className="read-more"
                    style={{
                      minWidth: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      transition:
                        "opacity 0.3s ease, visibility 0.3s ease, background-color 0.3s ease",
                      cursor: "pointer",
                      background: "var(--color-fourth)",
                      padding: "10px 20px",
                      fontSize: "16px",
                      textAlign: "center",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "var(--color-fourth)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "var(--color-fourth)";
                    }}
                  >
                    <Link
                      style={{
                        color: "white",
                        textDecoration: "none",
                      }}
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="video-section">
        <div className="video-with-content bg-color-primary">
          <div className="seeva-video">
            <div className="video-thumbnail">
              <img
                src="assets/img/section-img/young-woman-ophthalmologist-with-eye-chart_155003-7640.jpg"
                alt="Eye doctor, Dr. Lakdawala Eye Hospital"
              />
            </div>
          </div>
          <div className="container">
            <div className="row justify-content-lg-end justify-content-center">
              <div className="col-lg-5 col-md-9">
                <div className="video-content">
                  <div className="section-heading mb-20">
                    <span className="tagline">{t("videoSection.title1")}</span>
                    <h2 className="title">{t("videoSection.title2")}</h2>
                  </div>
                  <p>{t("videoSection.description")}</p>
                  <div className="mt-35 pr-xl-4">
                    {/*
                    <div className="wow fadeInUp" data-wow-delay="0.3s">
                      <FaCheckCircle className="text-primary me-2" />
                      {t("videoSection.point1")}{" "}
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.4s">
                      <FaCheckCircle className="text-primary me-2" />
                      {t("videoSection.point2")}{" "}
                    </div>
                */}{" "}
                  </div>
                  <Button
                    variant="outlined"
                    className="template-btn template-btn-bordered mt-40"
                    onClick={handleGetAppointmentClick}
                    style={{
                      backgroundColor: "transparent",

                      marginTop: "20px",
                      color: "white",
                    }}
                  >
                    {t("videoSection.getAppointment")}{" "}
                    <i className="far fa-plus" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AppointmentForm
        ref={appointmentRef}
        side="right"
        formData={formData}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
        imageNumber="2"
      />
    </Layouts>
  );
};

export default Services;
